module.exports = __webpack_public_path__ + "img/operator4.973f568e.png";